import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card border-0 bg-white profile-settings-card rounded-0" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_12 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_15 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_20 = ["required", "placeholder"]
const _hoisted_21 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_24 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_25 = ["required", "placeholder"]
const _hoisted_26 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_27 = { class: "col-12" }
const _hoisted_28 = { class: "mb-15 mb-sm-20 mb-md-25" }
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_31 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_32 = ["placeholder"]
const _hoisted_33 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_36 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_37 = ["placeholder"]
const _hoisted_38 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_41 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_42 = ["placeholder"]
const _hoisted_43 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_46 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_47 = ["placeholder"]
const _hoisted_48 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_49 = {
  key: 5,
  class: "col-12"
}
const _hoisted_50 = {
  key: 6,
  class: "col-md-12"
}
const _hoisted_51 = { class: "d-flex align-items-center justify-content-between flex-wrap gap-3" }
const _hoisted_52 = {
  key: 0,
  type: "button",
  class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium",
  "data-bs-toggle": "modal",
  "data-bs-target": "#confirmModal"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trash lh-1 me-1 position-relative top-2" }, null, -1 /* HOISTED */)
const _hoisted_54 = { class: "position-relative" }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { class: "d-flex flex-wrap gap-3 justify-content-end ms-auto" }
const _hoisted_57 = { class: "row justify-content-center" }
const _hoisted_58 = { class: "col" }
const _hoisted_59 = {
  class: "alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0 mb-25",
  role: "alert",
  id: "errorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_DiscardButton = _resolveComponent("DiscardButton")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createCommentVNode(" ANAGRAPH "),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t('form.section.user_information')), 1 /* TEXT */)
            ]),
            _createCommentVNode(" ROLE "),
            (!_ctx.role?.is_custom_role && _ctx.role_id_param === undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('form.role.label')) + "* ", 1 /* TEXT */),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("select", {
                        class: _normalizeClass(["form-select shadow-none text-black fs-md-15", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.role_id }]]),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.role_id) = $event)),
                        required: "",
                        disabled: _ctx.update
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.available_roles, (role) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: role.id,
                            key: role.id
                          }, _toDisplayString(role.name), 9 /* TEXT, PROPS */, _hoisted_10))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 10 /* CLASS, PROPS */, _hoisted_9), [
                        [_vModelSelect, _ctx.user.role_id]
                      ]),
                      _createCommentVNode(" ERRORS "),
                      (_ctx.errors?.role_id ?? false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.role_id, (error) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: error,
                                class: "small text-danger lh-1 m-0 mt-1"
                              }, _toDisplayString(error), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" ROLE_IN_DEPARTMENT "),
            (_ctx.is_hcp)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('form.role_in_department.label')), 1 /* TEXT */),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.role_in_department) = $event)),
                      class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.role_id }]])
                    }, null, 2 /* CLASS */), [
                      [_vModelText, _ctx.user.role_in_department]
                    ]),
                    _createCommentVNode(" ERRORS "),
                    (_ctx.errors?.role_in_department ?? false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.role_in_department, (error) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: error,
                              class: "small text-danger lh-1 m-0 mt-1"
                            }, _toDisplayString(error), 1 /* TEXT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _hoisted_16,
            (!_ctx.is_patient)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createCommentVNode(" FIRST NAME "),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('form.first_name.label')) + "* ", 1 /* TEXT */),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.firstname) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.firstname }]]),
                        required: !_ctx.is_patient,
                        placeholder: _ctx.$t('form.first_name.placeholder')
                      }, null, 10 /* CLASS, PROPS */, _hoisted_20), [
                        [_vModelText, _ctx.user.firstname]
                      ]),
                      _createCommentVNode(" ERRORS "),
                      (_ctx.errors?.firstname ?? false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.firstname, (error) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: error,
                                class: "small text-danger lh-1 m-0 mt-1"
                              }, _toDisplayString(error), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _createCommentVNode(" LAST NAME "),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('form.last_name.label')) + "* ", 1 /* TEXT */),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.lastname) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.lastname }]]),
                        required: !_ctx.is_patient,
                        placeholder: _ctx.$t('form.last_name.placeholder')
                      }, null, 10 /* CLASS, PROPS */, _hoisted_25), [
                        [_vModelText, _ctx.user.lastname]
                      ]),
                      _createCommentVNode(" ERRORS "),
                      (_ctx.errors?.lastname ?? false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.lastname, (error) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: error,
                                class: "small text-danger lh-1 m-0 mt-1"
                              }, _toDisplayString(error), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" CONTACTS "),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("h4", _hoisted_28, _toDisplayString(_ctx.$t('form.section.contacts')), 1 /* TEXT */)
            ]),
            _createCommentVNode(" UPDATE (DISABLED) "),
            (_ctx.update)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createCommentVNode(" EMAIL "),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('form.email.label')) + "* ", 1 /* TEXT */),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.email) = $event)),
                        type: "email",
                        class: "form-control shadow-none text-black",
                        required: "",
                        pattern: "[^@\\s]+@[^@\\s]+\\.[^@\\s]+",
                        placeholder: _ctx.$t('form.email.placeholder'),
                        disabled: ""
                      }, null, 8 /* PROPS */, _hoisted_32), [
                        [_vModelText, _ctx.user.email]
                      ]),
                      _createCommentVNode(" ERRORS "),
                      (_ctx.errors?.email ?? false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.email, (error) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: error,
                                class: "small text-danger lh-1 m-0 mt-1"
                              }, _toDisplayString(error), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _createCommentVNode(" PHONE "),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('form.phone.label')), 1 /* TEXT */),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.phone_number) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.phone_number }]]),
                        placeholder: _ctx.$t('form.phone.placeholder')
                      }, null, 10 /* CLASS, PROPS */, _hoisted_37), [
                        [_vModelText, _ctx.user.phone_number]
                      ]),
                      _createCommentVNode(" ERRORS "),
                      (_ctx.errors?.phine_number ?? false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.phone_number, (error) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: error,
                                class: "small text-danger lh-1 m-0 mt-1"
                              }, _toDisplayString(error), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _createCommentVNode(" CREATE "),
                  _createCommentVNode(" EMAIL "),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t('form.email.label')) + "* ", 1 /* TEXT */),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.email) = $event)),
                        type: "email",
                        class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.email }]]),
                        required: "",
                        pattern: "[^@\\s]+@[^@\\s]+\\.[^@\\s]+",
                        placeholder: _ctx.$t('form.email.placeholder')
                      }, null, 10 /* CLASS, PROPS */, _hoisted_42), [
                        [_vModelText, _ctx.user.email]
                      ]),
                      _createCommentVNode(" ERRORS "),
                      (_ctx.errors?.email ?? false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.email, (error) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: error,
                                class: "small text-danger lh-1 m-0 mt-1"
                              }, _toDisplayString(error), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _createCommentVNode(" PHONE "),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t('form.phone.label')), 1 /* TEXT */),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.user.phone_number) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.phone_number }]]),
                        placeholder: _ctx.$t('form.phone.placeholder')
                      }, null, 10 /* CLASS, PROPS */, _hoisted_47), [
                        [_vModelText, _ctx.user.phone_number]
                      ]),
                      _createCommentVNode(" ERRORS "),
                      (_ctx.errors?.phone_number ?? false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.phone_number, (error) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: error,
                                class: "small text-danger lh-1 m-0 mt-1"
                              }, _toDisplayString(error), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ], 64 /* STABLE_FRAGMENT */)),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _createVNode(_component_SpinnerLoading)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createCommentVNode(" DELETE "),
                    (_ctx.update)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_52, [
                          _hoisted_53,
                          _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t('cta.delete_user')), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_55)),
                    _createCommentVNode(" SAVE "),
                    _createElementVNode("div", _hoisted_56, [
                      _createVNode(_component_DiscardButton, {
                        onConfirm: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push({
                  path: _ctx.update ? _ctx.center_id != null ? `/center/${_ctx.center_id}` : `/user/${_ctx.user.id}` : '/system-users', query: {
                    center_id: _ctx.center_id
                  }
                })))
                      }),
                      _createElementVNode("button", {
                        class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
                        type: "submit",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.submitted = true))
                      }, _toDisplayString(_ctx.$t('cta.save_user')), 1 /* TEXT */)
                    ])
                  ])
                ]))
          ])
        ], 32 /* NEED_HYDRATION */)
      ])
    ]),
    _createCommentVNode(" ERROR MESSAGE "),
    _createElementVNode("div", _hoisted_57, [
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('error.something_went_wrong')), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.hideError && _ctx.hideError(...args))),
            "aria-label": "Close"
          })
        ])
      ])
    ]),
    _createVNode(_component_ConfirmModal, {
      onConfirm: _cache[12] || (_cache[12] = ($event: any) => (_ctx.deleteUser())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}